"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const surface_1 = require("../../../surface");
/**
 * HOC to bring inline error validation to our widgets.
 * @function withInlineValidation
 * @param WrappedComponent - widget
 * @returns - wrapped component with onBlur event and errorMessage
 */
const withInlineValidation = WrappedComponent => (props) => {
    const { label, schema: { title }, formContext: { blurredFields, onErrorTriggered, onBlur }, rawErrors } = props;
    const handleBlur = () => label && setTimeout(() => onBlur(label.replace(' ', '_').toLowerCase()), 0);
    // This sets the border to red and this cannot be done through the formTemplates for the field.
    const invalid = rawErrors &&
        rawErrors.length > 0 &&
        ((label && blurredFields.includes(label.toLowerCase().replace(' ', '_'))) ||
            onErrorTriggered);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ onBlur: handleBlur }, { children: jsx_runtime_1.jsx(WrappedComponent, Object.assign({ invalid: invalid }, props), void 0) }), void 0),
            invalid && jsx_runtime_1.jsx(surface_1.ErrorMessage, { text: `${label || title} ${rawErrors[0]}` }, void 0)] }, void 0));
};
exports.default = withInlineValidation;
//# sourceMappingURL=index.js.map